export function accountDetailsTable() {
    const table = $(".account-details-table");
    const moreBtn = table.find(".more .link");

    moreBtn.on("click", function (e) {
        e.preventDefault();
        if (!moreBtn.hasClass("open")) {
            moreBtn.addClass("open").text("Show less");
            table.find(".hidden-info").slideDown();
        } else {
            moreBtn.removeClass("open").text("Show more");
            table.find(".hidden-info").slideUp();
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/accountDetailsTable.js